import { findIndex, validateField } from './utils';
import { PropertyBoxType } from '../Block/types';

import { valueFields, valueNames } from '@v7/form/src/utils/BlockList/constants';
valueFields;
export const validateAllValueFields = (
  field1: any,
  field2: any,
  field3: any,
  value: any,
  propertyBoxState: any,
  errorList: any,
  setErrorList: any,
  setPropertyBoxState: (state: any) => void,
) => {
  validateField(field1, value, propertyBoxState, errorList, setErrorList, setPropertyBoxState);
  if (!field1.error) {
    validateField(field2, field2.value, propertyBoxState, errorList, setErrorList, setPropertyBoxState);
    validateField(field3, field3.value, propertyBoxState, errorList, setErrorList, setPropertyBoxState);
  }
};

const selectTypes: any = {
  select: 'select',
  multi: 'multiSelect',
  radio: 'radio',
};
export const validateValueFields = (
  field: any,
  value: any,
  propertyBoxState: any,
  errorList: any,
  setErrorList: any,
  setPropertyBoxState: (state: any) => void,
) => {
  try {
    const valueFieldIndex = findIndex(Object.values(propertyBoxState), 'value');
    const minFieldIndex = findIndex(Object.values(propertyBoxState), 'minLength');
    const maxFieldIndex = findIndex(Object.values(propertyBoxState), 'maxLength');
    const minField =
      minFieldIndex >= 0
        ? Object.values(propertyBoxState)[minFieldIndex]
        : propertyBoxState[findIndex(Object.values(propertyBoxState), 'min')];
    const maxField =
      minFieldIndex >= 0
        ? Object.values(propertyBoxState)[maxFieldIndex]
        : propertyBoxState[findIndex(Object.values(propertyBoxState), 'max')];
    const valueField = Object.values(propertyBoxState)[valueFieldIndex] as PropertyBoxType;
    if (field.key === 'value')
      validateAllValueFields(
        valueField,
        minField,
        maxField,
        value,
        propertyBoxState,
        errorList,
        setErrorList,
        setPropertyBoxState,
      );
    else if (['minLength', 'min'].includes(field.key))
      validateAllValueFields(
        minField,
        maxField,
        valueField,
        value,
        propertyBoxState,
        errorList,
        setErrorList,
        setPropertyBoxState,
      );
    else
      validateAllValueFields(
        maxField,
        minField,
        valueField,
        value,
        propertyBoxState,
        errorList,
        setErrorList,
        setPropertyBoxState,
      );
  } catch (e) {
    console.error(e);
  }
};

export const onInputComponentChange = (
  field: any,
  value: any,
  propertyBoxState: any,
  errorList: any,
  setErrorList: any,
  setPropertyBoxState: (state: any) => void,
) => {
  if (valueFields.includes(field.key) && valueNames.includes(field.name) && !selectTypes[field.type])
    validateValueFields(field, value, propertyBoxState, errorList, setErrorList, setPropertyBoxState);
  else validateField(field, value, propertyBoxState, errorList, setErrorList, setPropertyBoxState);
};
